export default "__VITE_ASSET__zY2BnJPa__"